// The app's line icons (16-unit stroke glyphs, currentColor, like the search field's). Styles: book.css `.icon`.
const PATHS = {
  // a chain link: Connect, connection links
  link: "M6.6 9.4a2.8 2.8 0 0 0 4 0l2.2-2.2a2.8 2.8 0 0 0-4-4l-1 1M9.4 6.6a2.8 2.8 0 0 0-4 0L3.2 8.8a2.8 2.8 0 0 0 4 4l1-1",
  plus: "M8 3v10M3 8h10",
  // the nav's views: the board (three columns), chats (a speech bubble), the graph (linked nodes), secrets (a key)
  board: "M2.5 3h11v10h-11z M6.2 3v10 M9.8 3v10",
  chats: "M3 3.5h10a.5.5 0 0 1 .5.5v6.5a.5.5 0 0 1-.5.5H7l-3 2.5V11H3a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5z",
  graph: "M5.5 4a1.5 1.5 0 1 1-3 0a1.5 1.5 0 1 1 3 0z M13.5 5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 1 1 3 0z M9 12a1.5 1.5 0 1 1-3 0a1.5 1.5 0 1 1 3 0z M5.5 4.2l5 .6 M4.6 5.4l2.4 5.2 M11.2 6.3l-3 4.4",
  secrets: "M10 2.5a3.5 3.5 0 1 1-3.3 4.6L2.5 11.3V13.5h2.2v-1.5h1.5v-1.5h1.5l1-1A3.5 3.5 0 0 1 10 2.5z M11 5.5h.01",
  // a space's type (truss Space.type): an organisation (a building), a team (two people), a project (a folder),
  // someone's personal space (one person)
  org: "M3 13.5V3.5h6.5v10 M9.5 6.5H13v7 M2 13.5h12 M5 5.5h2 M5 8h2 M5 10.5h2 M11 9h.5 M11 11h.5",
  team: "M6 7a2 2 0 1 0 0-4a2 2 0 1 0 0 4z M2.5 13c.3-2.2 1.7-3.5 3.5-3.5s3.2 1.3 3.5 3.5 M10.5 7.2a1.7 1.7 0 1 0 0-3.4 M11.5 9.6c1.2.4 1.9 1.6 2 3.4",
  project: "M2.5 4.5a1 1 0 0 1 1-1h3l1.5 1.5h4.5a1 1 0 0 1 1 1v6.5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1z",
  personal: "M8 7.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 1 0 0 5z M3.5 13.5c.4-2.6 2.2-4 4.5-4s4.1 1.4 4.5 4",
  // drag to reorder: two columns of dots
  grip: "M6 4h.01 M10 4h.01 M6 8h.01 M10 8h.01 M6 12h.01 M10 12h.01",
  // the board filter: three lines narrowing
  filter: "M2.5 4.5h11M4.5 8h7M6.5 11.5h3",
  // back to the nav: a chevron left
  back: "M10 3.5L5.5 8l4.5 4.5",
  // change: a pencil
  pencil: "M10.5 3.5l2 2L6 12l-2.6.6L4 10z M9.3 4.7l2 2",
  // remove: a bin
  trash: "M3 4.5h10M6.5 4.5V3h3v1.5M4.5 4.5l.6 8.5h5.8l.6-8.5M7 7v4M9 7v4"
} as const;
export type IconName = keyof typeof PATHS;

/** `d`: a path of its own (a kind view's nav entry) in place of a named one */
export function Icon({
  name,
  d,
  size = 16
}: {
  name?: IconName;
  d?: string;
  size?: number;
}) {
  return <svg className="icon" viewBox="0 0 16 16" width={size} height={size} aria-hidden>
			<path d={d ?? (name ? PATHS[name] : "")} />
		</svg>;
}